import { useEffect, useState } from "react";
import { DashboardService } from "../../Api/Dashboard/Dashboard";
import { ErrorMsgToaster } from "../Utils/Toaster";
import NoCourse from "../Common/NoCourse";
import CourseTail from "./CourseTail";
import { TrendingCourseType } from "../../Utils/types";
import { ThemeProps } from "../../Themes/Themes";

const TrendingCourse = ({ theme }: { theme: ThemeProps }) => {
  const [trendingCourse, setTrendingCourse] = useState<TrendingCourseType>();

  useEffect(() => {
    let isMounted = true; // Flag to track if component is mounted

    const dashboardService = new DashboardService();
    dashboardService
      .getTrendingCourse()
      .then((resData) => {
        if (resData.data && isMounted) {
          // Only update state if component is still mounted
          setTrendingCourse(resData.data);
        }
      })
      .catch((err) => {
        if (isMounted) {
          console.log(err, "err for trending");
          ErrorMsgToaster(err);
        }
      });

    // Cleanup function - runs when component unmounts
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      {trendingCourse ? (
        <CourseTail
          courseData={trendingCourse}
          key={trendingCourse?.courseId}
          theme={theme}
        />
      ) : (
        <NoCourse title='Nothing Here' icon='school' />
      )}
    </>
  );
};

export default TrendingCourse;
